import image from "../../assets/jujingyi.jpg";

export const CATEGORY = [
  {
    img: "",
    p: "Aenean sit amet gravida nisi. Nam fermentum est felis, quis feugiat nunc fringilla sit amet. Ut in blandit ipsum. Quisque luctus dui at ante aliquet, in hendrerit lectus interdum. Morbi elementum sapien rhoncus pretium maximus. Nulla lectus enim, cursus et elementum sed, sodales vitae eros. Ut ex quam, porta consequat interdum in, faucibus eu velit. Quisque rhoncus ex ac libero varius molestie. Aenean tempor sit amet orci nec iaculis. Cras sit amet nulla libero. Curabitur dignissim, nunc nec laoreet consequat, purus nunc porta lacus, vel efficitur tellus augue in ipsum. Cras in arcu sed metus rutrum iaculis. Nulla non tempor erat. Duis in egestas nunc.",
    console1: "",
    console2: "",
    console3: "",
    console4: "",
  },
  {
    img: "",
    title: "Category",
    category: "Kids and Family Games",
    onSale: "On Sale",
    answer: "Yes",
    available: "Available On:",
    console1: "PS4",
    console2: "PS5",
    console3: "Android",
    console4: "Iphone",
    p: "",
  },
  {
    img: image,
    name: "Ju Jingyi",
    feedback:
      "Determination, courage, love, hatred... all of these will be degraded and distorted by the incessant flow of time.",
    warning:
      "Your email address will not be published. Required fields are marked *",
    console1: "",
    console2: "",
    console3: "",
    console4: "",
    p: "",
  },
];
